/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SendPaperplaneDiagIcon16Solid = forwardRef('SendPaperplaneDiagIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M13.022 1.395 1.38 5.247a1 1 0 0 0-.244 1.78l3.366 2.265a1 1 0 0 0 1.266-.123l2.995-2.995a.75.75 0 0 1 1.06 1.06L6.828 10.23a1 1 0 0 0-.123 1.265l2.261 3.361a1 1 0 0 0 1.78-.243L14.6 2.975c.323-.976-.604-1.903-1.58-1.58Z" })));
});
